import axios from "axios";

const BASE = `${process.env.REACT_APP_API_URL}/certificate-template`;

// ── Types ─────────────────────────────────────────────────────────────────────

export interface CustomCertificateTemplate {
  id?: number;
  classId?: number;
  sessionId?: number;
  className?: string;
  sessionName?: string;
  templateName: string;
  category: string; // e.g. SPORTS, ACADEMIC, EVENT, TC, APPRECIATION, etc.
  canvasJson: string;
  svgContent: string;
  primary?: boolean;
  createdBy?: number;
  updatedBy?: number;
  createdAt?: number[];
  updatedAt?: number[];
}

// ── API 1: List templates for a class+session ──────────────────────────────────

export async function listCertificateTemplatesFromApi(
  className: string,
  sessionId: number
): Promise<CustomCertificateTemplate[]> {
  const res = await axios.get<CustomCertificateTemplate[]>(
    `${BASE}/${encodeURIComponent(className)}/${sessionId}`
  );
  return res.data ?? [];
}

// ── API 2: List templates by category ──────────────────────────────────────────

export async function listCertificateTemplatesByCategory(
  category: string
): Promise<CustomCertificateTemplate[]> {
  const res = await axios.get<CustomCertificateTemplate[]>(
    `${BASE}/category/${encodeURIComponent(category)}`
  );
  return res.data ?? [];
}

// ── API 3: Get a single template details ───────────────────────────────────────

export async function getCertificateTemplateById(
  id: number
): Promise<CustomCertificateTemplate> {
  const res = await axios.get<CustomCertificateTemplate>(`${BASE}/${id}`);
  return res.data;
}

// ── API 4: Create template ─────────────────────────────────────────────────────

export async function createCertificateTemplate(
  template: CustomCertificateTemplate
): Promise<CustomCertificateTemplate> {
  const res = await axios.post<CustomCertificateTemplate>(BASE, template);
  return res.data;
}

// ── API 5: Update template ─────────────────────────────────────────────────────

export async function updateCertificateTemplate(
  template: CustomCertificateTemplate
): Promise<CustomCertificateTemplate> {
  const res = await axios.put<CustomCertificateTemplate>(BASE, template);
  return res.data;
}

// ── API 6: Set template as primary ─────────────────────────────────────────────

export async function setPrimaryCertificateTemplate(
  id: number
): Promise<CustomCertificateTemplate> {
  const res = await axios.put<CustomCertificateTemplate>(`${BASE}/${id}`);
  return res.data;
}

// ── API 7: Delete template ─────────────────────────────────────────────────────

export async function deleteCertificateTemplate(id: number): Promise<void> {
  await axios.delete(`${BASE}/${id}`);
}
